import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap"; // ✅ Added Modal & Button
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import "./../summeryTableStyle.css"
import jsPDF from "jspdf";
import "jspdf-autotable";
// import customFont from './NotoSansMalayalam-VariableFont_wdth,wght-normal.js';

const ArthiksakhaJillaUthsavamShreniReport = () => {
    const { auth } = useAuth();
    const [pdfUrl, setPdfUrl] = useState("");

    // const [UthsavamReport, setUthsavamReport] = useState([]);
    const [UthsavamReport, setUthsavamReport] = useState({
        jilla_name: "",
        data: [],
    });

    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);;
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const [pranthList, setPranthList] = useState([]);

    const [selectedJillaId, setSelectedJillaId] = useState(auth?.parent_id);
    const [selectedJillaName, setSelectedJillaName] = useState("");
    const [jillaList, setJillaList] = useState([]);
    const [loading, setLoading] = useState(true);

    const [hasSearched, setHasSearched] = useState(false); // 👈 NEW
    const [pdfGenerating, setPdfGenerating] = useState(false);
    const tableRef = useRef(null);


    useEffect(() => {
        const getPranths = async () => {
            const data = await fetchPranthList(); // Get data from the service
            setPranthList(data);                  // Set data to state
        };

        getPranths();
    }, []);

    const fetchJillaUthsavamReport = useCallback(async () => {
        if (!selectedJillaId) return;  // 🛑 Prevent API call if undefined or empty
        setLoading(true);
        setError(null);
        setHasSearched(true);
        try {
            const url = `reports/jilla-uthsavam-shreni-report?jilla_id=${selectedJillaId}`;
            const response = await axiosPrivate.get(url, { withCredentials: true });
            setLoading(false);
            if (response.status === 204) {
                // ✅ No Content case
                setUthsavamReport([]);
                setLoading(false);
                setError("No Data available.");
                return;
            }

            // ✅ Handle valid data
            // setUthsavamReport(Array.isArray(response.data) ? response.data : []);
            setUthsavamReport(response.data);


        } catch (error) {
            console.error("Error fetching Data:", error);
            setError(error?.response?.data?.message || "No Data available.");
            setUthsavamReport([]); // Clear old data in case of error
            setLoading(false);
        }
    }, [axiosPrivate, selectedJillaId]);

    useEffect(() => {
        fetchJillaUthsavamReport();
    }, [selectedJillaId]);


    const downloadPDF = async () => {
        if (!selectedJillaId) return;

        try {
            const response = await axiosPrivate.get(
                `reports/jilla-uthsavam-shreni-report?jilla_id=${selectedJillaId}&download=1`,
                {
                    responseType: "blob",
                    withCredentials: true,
                }
            );

            const blob = new Blob([response.data], {
                type: "application/pdf",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `Jilla_Uthsavam_Shreni_Report_${selectedJillaName}.pdf`;

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Download failed", err);
            alert("Failed to download PDF.");
        }
    };

    return (
        <>
            <style>{`
  #customers th, #customers td {

    min-width: 144px;
  }`}</style>

            <section className="empbody">
                <div className="wrapperemp2">
                    {/* ✅ Finalize Button with Modal trigger */}

                    <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
                    <div className="d-flex justify-content-end">

                        <button
                            type="button"
                            className="btn btn-success newviewbtn"
                            onClick={downloadPDF}
                        // disabled={!pdfUrl || pdfGenerating}
                        >
                            {pdfGenerating ? (
                                "Generating..."
                            ) : (
                                <>
                                    <i className="bx bx-download me-1"></i>
                                    Download PDF
                                </>
                            )}
                        </button>
                    </div>

                    <div
                    // className="d-flex justify-content-end align-items-center gap-2 mb-3"
                    >
                    </div>

                    <h3>Jilla Uthsavam Shreni Report</h3>


                    <div className="table-container">

                        {hasSearched && (
                            <div className="table-container">
                                {UthsavamReport?.jilla_name && (
                                    <>
                                        <b
                                            style={{
                                                textAlign: "left",
                                                color: "black",
                                            }}
                                        >
                                            ജില്ല/മഹാനഗരം:
                                        </b>{" "}
                                        <span style={{ color: "black" }}>{UthsavamReport.jilla_name}</span>
                                    </>
                                )}
                                {hasSearched && (
                                    // <table id="customers" className="table table-bordered text-center summary-table">

                                    // <table class="gurupooja-table">
                                    <table ref={tableRef} className="gurupooja-table">
                                        <thead>
                                            <tr>
                                                <th rowSpan="3" className="vertical">
                                                    <span>ക്രമസംഖ്യ</span>
                                                </th>
                                                <th rowSpan="3" className="center">
                                                    ഖണ്ഡ്/നഗരം
                                                </th>

                                                <th colSpan="5" className="center">ബാലന്മാരുടെ മാത്രം</th>
                                                <th colSpan="3" className="center">തരുണ + പ്രൗഢ + <br></br> അനുഭാവി മാത്രം</th>
                                                <th colSpan="3" className="center">തരുണ വിദ്യാർത്ഥികളുടെ <br></br>  മാത്രം</th>
                                                <th colSpan="3" className="center">5000 രൂപയിൽ കൂടുതൽ <br></br>  സമർപ്പിച്ചവർ</th>
                                                <th colSpan="2" className="center">ഗംഗാജലി</th>
                                            </tr>

                                            {/* New row */}
                                            <tr>
                                                <th colSpan="3" className="center">ഉപസ്ഥിതി</th>
                                                <th rowSpan="2" className="center">തുക</th>
                                                <th rowSpan="2" className="vertical">പ്രതിശീർഷം</th>

                                                <th rowSpan="2" className="vertical">ഉപസ്ഥിതി</th>
                                                <th rowSpan="2" className="center">തുക</th>
                                                <th rowSpan="2" className="vertical">പ്രതിശീർഷം</th>

                                                <th rowSpan="2" className="vertical">ഉപസ്ഥിതി</th>
                                                <th rowSpan="2" className="center">തുക</th>
                                                <th rowSpan="2" className="vertical">പ്രതിശീർഷം</th>

                                                <th rowSpan="2" className="vertical">ഉപസ്ഥിതി</th>
                                                <th rowSpan="2" className="center">തുക</th>
                                                <th rowSpan="2" className="vertical">പ്രതിശീർഷം</th>

                                                <th rowSpan="2" className="vertical">എത്ര സ്ഥലത്ത്</th>
                                                <th rowSpan="2" className="vertical">സ്വയംസേവകർ</th>
                                            </tr>

                                            {/* Third row */}
                                            <tr>
                                                <th className="vertical">ബാല</th>
                                                <th className="vertical">ശിശു</th>
                                                <th className="vertical">ആകെ</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {loading ? (
                                                <tr>
                                                    <td colSpan="23" className="text-center">
                                                        Loading...
                                                    </td>
                                                </tr>
                                            ) : UthsavamReport?.data?.length > 0 ? (
                                                UthsavamReport.data.map((item, index) => {
                                                    const balaTotal =
                                                        (item.Bala || 0) +
                                                        (item.Sisu || 0);

                                                    const uTotal =
                                                        (item.U_Sakha || 0) +
                                                        (item.U_PrayathnaSakha || 0) +
                                                        (item.U_Milan || 0) +
                                                        (item.U_SanghaMandali || 0) +
                                                        (item.U_Other || 0);

                                                    return (
                                                        <tr key={item.khand_id}>
                                                            <td className="center">{index + 1}</td>
                                                            <td className="center">{item.khand_name}</td>

                                                            {/* ബാലന്മാരുടെ മാത്രം */}
                                                            <td className="center">{item.Bala ?? 0}</td>
                                                            <td className="center">{item.Sisu ?? 0}</td>
                                                            <td className="center">{balaTotal}</td>
                                                            <td className="center">{item.BalaAmount ?? 0}</td>
                                                            <td className="center">{item.BalaAvgAmount ?? 0}</td>

                                                            {/* തരുണ + പ്രൗഢ + അനുഭാവി മാത്രം */}
                                                            <td className="center">{item.TharunaProuda ?? 0}</td>
                                                            <td className="center">{item.TPA_Amount ?? 0}</td>
                                                            <td className="center">{item.TPA_AvgAmount ?? 0}</td>


                                                            {/* തരുണ വിദ്യാർത്ഥികളുടെ മാത്രം */}
                                                            <td className="center">{item.TharunaVidyarthi ?? 0}</td>
                                                            <td className="center">{item.TV_Amount ?? 0}</td>
                                                            <td className="center">{item.TV_AvgAmt ?? 0}</td>

                                                            {/* 5000 രൂപയിൽ കൂടുതൽ സമർപ്പിച്ചവർ */}
                                                            <td className="center">{item.Above5K ?? 0}</td>
                                                            <td className="center">{item.Above5K_Amt ?? 0}</td>
                                                            <td className="center">{item.Above5K_AvgAmt ?? 0}</td>

                                                            {/* ഗംഗാജലി */}
                                                            <td className="center"></td>
                                                            <td className="center"></td>

                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="23" className="text-center">
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            {UthsavamReport?.data?.length > 0 && (
                                                <tr>
                                                    <td></td>
                                                    <td><strong>ആകെ</strong></td>

                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.Bala || 0), 0)}</td>
                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.Sisu || 0), 0)}</td>
                                                    <td className="center">
                                                        {UthsavamReport.data.reduce(
                                                            (a, b) => a +
                                                                (b.Bala || 0) +
                                                                (b.Sisu || 0),
                                                            0)}
                                                    </td>
                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.BalaAmount || 0), 0)}</td>
                                                    <td className="center">
                                                        {(() => {
                                                            const totalCount = UthsavamReport.data.reduce(
                                                                (a, b) => a + (b.Bala || 0) + (b.Sisu || 0),
                                                                0
                                                            );

                                                            const totalAmount = UthsavamReport.data.reduce(
                                                                (a, b) => a + (b.BalaAmount || 0),
                                                                0
                                                            );

                                                            return totalCount > 0
                                                                ? Math.round(totalAmount / totalCount)
                                                                : 0;
                                                        })()}
                                                    </td>


                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.TharunaProuda || 0), 0)}</td>
                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.TPA_Amount || 0), 0)}</td>
                                                    <td className="center">
                                                        {(() => {
                                                            const totalCount = UthsavamReport.data.reduce(
                                                                (a, b) => a + (b.TharunaProuda || 0),
                                                                0
                                                            );

                                                            const totalAmount = UthsavamReport.data.reduce(
                                                                (a, b) => a + (b.TPA_Amount || 0),
                                                                0
                                                            );

                                                            return totalCount > 0
                                                                ? Math.round(totalAmount / totalCount)
                                                                : 0;
                                                        })()}
                                                    </td>


                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.TharunaVidyarthi || 0), 0)}</td>
                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.TV_Amount || 0), 0)}</td>
                                                    <td className="center">
                                                        {(() => {
                                                            const totalCount = UthsavamReport.data.reduce(
                                                                (a, b) => a + (b.TharunaVidyarthi || 0),
                                                                0
                                                            );

                                                            const totalAmount = UthsavamReport.data.reduce(
                                                                (a, b) => a + (b.TV_Amount || 0),
                                                                0
                                                            );

                                                            return totalCount > 0
                                                                ? Math.round(totalAmount / totalCount)
                                                                : 0;
                                                        })()}
                                                    </td>


                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.Above5K || 0), 0)}</td>
                                                    <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.Above5K_Amt || 0), 0)}</td>
                                                    {/* <td className="center">{UthsavamReport.data.reduce((a, b) => a + (b.Above5K_Amt || 0), 0)}/{UthsavamReport.data.reduce((a, b) => a + (b.Above5K || 0), 0)}</td> */}
                                                    <td className="center">
                                                        {(() => {
                                                            const totalAmt = UthsavamReport.data.reduce((a, b) => a + (b.Above5K_Amt || 0), 0);
                                                            const totalCount = UthsavamReport.data.reduce((a, b) => a + (b.Above5K || 0), 0);

                                                            return totalCount ? Math.round(totalAmt / totalCount) : 0;
                                                        })()}
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            )}
                                        </tfoot>
                                    </table>
                                    // </table>
                                )}
                            </div>
                        )}
                    </div>
                </div >
            </section >

            <TopBar />
        </>
    );
};

export default ArthiksakhaJillaUthsavamShreniReport;
